import React, {Component} from "react";
import {Modal} from "react-bootstrap";
import moment from "moment";

import {MapWrapperComponent} from "../../map/mapWrapper";
import {fetchDeviceDetail} from "../../../../services/deviceService";
import {DeviceInfoItem} from "./deviceInfoItem";
import {fetchTimeValue,EpochtoEpochTZ} from "../../../../shared/utils.js";
import {dateFormat, defaultLatitude, defaultLongitude} from "../../../../Constant";
import PropTypes from "prop-types";


export class DeviceDetailModal extends Component {

    constructor(props) {
        super(props);
        let protocol = window.location.protocol;
        let imgUrl = `${protocol}//gps.chalo.com/assets/images`;
        this.state = {
            data: this.props.data,
            center: {
                lat: parseFloat(this.props.data.latitude),
                lng: parseFloat(this.props.data.longitude)
            },
            icon: {
                url: `${imgUrl}/device.png`,
                scaledSize: {
                    width: 40,
                    height: 57
                }
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            this.setState({
                data: this.props.data
            });
            if (this.props.data.latitude != prevProps.data.longitude) {
                if (parseFloat(this.props.data.latitude)) {
                    this.setState({
                        center: {
                            lat: parseFloat(this.props.data.latitude),
                            lng: parseFloat(this.props.data.longitude)
                        }
                    });
                } else {
                    this.setState({
                        center: {
                            lat: defaultLatitude,
                            lng: defaultLongitude
                        }
                    });
                }
            }
        }
    }

    componentDidMount() {
        this.fetchDeviceDetail();
    }


    render() {
        const backdrop = 'static';
        const {data, center}=this.state;
        return (
            <Modal show={this.props.showModal} onHide={()=>this.props.messageCallback(null, null)} backdrop={backdrop}
                   dialogClassName="device-info-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Device Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row device-info">
                        <div className="col-sm-7 device-detail-info">
                            <div className="w-50 device-detail-info-container">
                                <DeviceInfoItem label="Device Id" value={data.deviceId}/>
                                <DeviceInfoItem label="Vehicle No." value={data.vehicleNo}/>
                                <DeviceInfoItem label="Protocol" value={data.protocol}/>
                                <DeviceInfoItem label="Latitude" value={data.latitude}/>
                                <DeviceInfoItem label="Longitude" value={data.longitude}/>
                                <DeviceInfoItem label="Time in Packet"
                                                value={parseInt(data.lastPacketTimestamp) ? moment(new Date(EpochtoEpochTZ(parseInt(data.lastPacketTimestamp),localStorage.getItem('timeZone')))).format(dateFormat) : 'NA'}/>
                                <DeviceInfoItem label="Last Arrived At"
                                                value={parseInt(data.lastPacketArriveAt) ? moment(new Date(EpochtoEpochTZ(parseInt(data.lastPacketArriveAt),localStorage.getItem('timeZone')))).format(dateFormat) : 'NA'}/>
                                <DeviceInfoItem label="Last Posted At"
                                                value={parseInt(data.lastPacketPostedAt) ? moment(new Date(EpochtoEpochTZ(parseInt(data.lastPacketPostedAt),localStorage.getItem('timeZone')))).format(dateFormat) : 'NA'}/>
                                <DeviceInfoItem label="Last Parsing Time"
                                                value={`${fetchTimeValue(this.props.timeParse, parseInt(data.lastPacketParsingTime), null)} ${this.props.timeParse}`}/>
                                <DeviceInfoItem label="Last Posting Time"
                                                value={`${fetchTimeValue(this.props.timeParse, parseInt(data.lastPacketPostingTime), null)} ${this.props.timeParse}`}/>
                                <DeviceInfoItem label="Delay"
                                                value={`${fetchTimeValue(this.props.timeParse, parseInt(data.delay), null)} ${this.props.timeParse}`}/>
                                <DeviceInfoItem label="Packet Status" value={data.packetStatus}/>
                                <DeviceInfoItem label="GPS Signal" value={data.signal}/>
                                <DeviceInfoItem label="Offset Type" value={data.offsetType ?? 'NA'}/>
                            </div>
                            <div className="w-50 device-detail-info-container">
                                <DeviceInfoItem label="Speed" value={data.speed ?? 'NA'}/>
                                <DeviceInfoItem label="Direction" value={data.Direction ?? 'NA'}/>
                                <DeviceInfoItem label="Power Status" value={data.powerStatus ?? 'NA'}/>
                                <DeviceInfoItem label="Ignition Status" value={data.ignitionStatus ?? 'NA'}/>
                                <DeviceInfoItem label="Harsh Acceleration" value={data.harshAcceleration ?? 'NA'}/>
                                <DeviceInfoItem label="Harsh Braking" value={data.harshBraking ?? 'NA'}/>
                                <DeviceInfoItem label="Rash Turning" value={data.rashTurning ?? 'NA'}/>
                                <DeviceInfoItem label="Input Voltage" value={data.inputVoltage ?? 'NA'}/>
                                <DeviceInfoItem label="Firmware Version" value={data.firmwareVersion ?? 'NA'}/>
                                <DeviceInfoItem label="Packet Type" value={data.packetType ?? 'NA'}/>
                                <DeviceInfoItem label="Packet State" value={data.packetState ?? 'NA'}/>
                                <DeviceInfoItem label="Frame Number" value={data.frameNumber ?? 'NA'}/>
                                <DeviceInfoItem label="Network Operator" value={data.networkOperator ?? 'NA'}/>
                            </div>
                        </div>
                        <div className="col-sm-5 map-wrapper">
                            <div className="row device-detail-map">
                                <MapWrapperComponent data={data} center={center} icon={this.state.icon}/>
                            </div>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        );
    }

    fetchDeviceDetail() {
        this.intervalId = setInterval(()=> {
            if (this.props.showModal)
                fetchDeviceDetail(this.props.data.deviceId, this.props.regionId).then((response)=> {
                    this.setState({data: response});
                }).catch(function (err) {
                    console.log(err);
                });
        }, 10000);

    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }
}


DeviceDetailModal.propTypes = {
  showModal: PropTypes.bool,
  data: PropTypes.object,
  timeParse: PropTypes.string,
  regionId: PropTypes.string,
  messageCallback: PropTypes.func,
};